import authRoutes from '../Auth/routes';
import contentRoutes from '../Content/routes';
import buyRoutes from '../Buy/routes';
import mealPlanRoutes from '../MealPlan/routes';
import knowledgeRoutes from '../Knowledge/routes';
import achievementsRoutes from '../Achievements/routes';
import hydrationRoutes from '../Hydration/routes';
import removeAccountRoutes from '../RemoveAccount/routes';
import measurementsRoutes from '../Measurements/routes';
import biometricSettingsRoutes from '../BiometricSettings/routes';
import goalSettingsRoutes from '../GoalSettings/routes';
import dietSettingsRoutes from '../DietSettings/routes';
import mealPlanSettingsRoutes from '../MealPlanSettings/routes';
import checkoutRoutes from '../Checkout/routes';
import cookbookRoutes from '../Cookbook/routes';
import activateProductRoutes from '../ActivateProduct/routes';
import feedbackRoutes from '../Feedback/routes';
import trackerRoutes from '../Tracker/routes';

import { Route } from './types';

const allRoutes: Route[] = [
  ...authRoutes,
  ...contentRoutes,
  ...buyRoutes,
  ...mealPlanRoutes,
  ...knowledgeRoutes,
  ...achievementsRoutes,
  ...hydrationRoutes,
  ...removeAccountRoutes,
  ...measurementsRoutes,
  ...biometricSettingsRoutes,
  ...goalSettingsRoutes,
  ...dietSettingsRoutes,
  ...mealPlanSettingsRoutes,
  ...checkoutRoutes,
  ...cookbookRoutes,
  ...activateProductRoutes,
  ...feedbackRoutes,
  ...trackerRoutes,
];

export default allRoutes;
